import { configureStore, Store } from "@reduxjs/toolkit"
import ordersReducer from "@hydrologiq/orders/state/slice/ordersSlice"
import { reducers as sharedReducers } from "@hydrologiq/shared/state/store"
const store: Store = configureStore({
  reducer: {
    orders: ordersReducer,
    ...sharedReducers,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [],
        // // Ignore these field paths in all actions
        // ignoredActionPaths: ["meta.arg", "payload.timestamp"],
        // Ignore these paths in the state
        ignoredPaths: [],
      },
    }),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
export default store
